import { runtimeConfig } from './runtime-config';

const normalizeApiUrl = (url: string): string => {
    let normalizedUrl = url.trim().replace(/\/+$/, '');

    if (!normalizedUrl.endsWith('/api')) {
        normalizedUrl = `${normalizedUrl}/api`;
    }

    return normalizedUrl;
};

export const API_URL = normalizeApiUrl(runtimeConfig.apiUrl);
export const API_V1_URL = `${API_URL}/v1`;